import { useNavigate } from 'react-router-dom';
import { T, PageHeader } from './UI';

export default function OptionChooser({ title, prompt, options, backPath }) {
  const navigate = useNavigate();

  return (
    <div style={T.page}>
      <PageHeader title={title} onBack={() => navigate(backPath || -1)} />

      <div style={{ maxWidth: '520px', margin: '0 auto', padding: '20px 16px 100px' }}>
        {prompt && (
          <p style={{ fontSize: '13px', color: 'var(--muted)', marginBottom: '16px' }}>{prompt}</p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {options.map(opt => (
            <button key={opt.key} type="button" onClick={() => navigate(opt.path)}
              style={{
                display: 'flex', alignItems: 'center', gap: '14px',
                width: '100%', textAlign: 'left',
                background: 'var(--surface)', border: '1px solid var(--border)',
                borderRadius: 'var(--radius-lg)', padding: '18px', cursor: 'pointer',
                fontFamily: 'inherit', transition: 'border-color .15s, background .15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--blue)'; e.currentTarget.style.background = 'var(--blue-light)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--surface)'; }}>
              <div style={{ width: '46px', height: '46px', background: 'var(--blue)', borderRadius: 'var(--radius)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className={`ti ${opt.icon}`} style={{ fontSize: '22px', color: '#fff' }} aria-hidden="true" />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: '500', color: 'var(--text)' }}>{opt.title}</div>
                <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '2px' }}>{opt.subtitle}</div>
              </div>
              <i className="ti ti-chevron-right" style={{ fontSize: '18px', color: 'var(--hint)', flexShrink: 0 }} aria-hidden="true" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
